import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import { Typography, Button, Snackbar, Alert, CircularProgress } from "@mui/material";
import { useTranslation } from 'react-i18next';

function Activation() {
    const { t, i18n } = useTranslation();
    const { config, environment } = require('../../index'); // config.js
    const navigate = useNavigate();
    const { uid, token } = useParams(); // from URL /activation/:uid/:token

    const [loading, setLoading] = useState(true);
    const [activated, setActivated] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMsg, setSnackMsg] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("success");

    // On mount: POST activation request to backend
    useEffect(() => {
        const activateAccount = async () => {
            try {
                await Axios.post(config[environment].activationEndpoint, { uid, token });
                setActivated(true);
                setSnackMsg(t('Administration.ActivationSuccess', "Fiók sikeresen aktiválva! Kérlek jelentkezz be."));
                setSnackSeverity("success");
                setSnackOpen(true);

                // Redirect to login after short delay
                setTimeout(() => navigate(`/${i18n.language}/login`), 2000);
            } catch (error) {
                console.error("[Activation] Failed:", error.response?.data || error);
                let message = t('Administration.ActivationFailed', "Fiók aktiválása sikertelen. Ellenőrizd a linket vagy próbáld újra.");
                if (error.response?.status === 400) {
                    message = t('Administration.InvalidActivationLink', "A link érvénytelen vagy lejárt.");
                }
                setSnackMsg(message);
                setSnackSeverity("error");
                setSnackOpen(true);
            } finally {
                setLoading(false);
            }
        };

        if (uid && token) activateAccount();
    }, [uid, token, config, environment, navigate]);

    return (
        <div style={{ textAlign: "center", marginTop: "100px", maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto' }}>
            <Typography variant="h4" gutterBottom>
                {t('Administration.ActivationTitle', "Fiók aktiválása")}
            </Typography>

            {loading && <CircularProgress sx={{ mt: 2 }} />}

            {!loading && !activated && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.location.reload()}
                    sx={{ mt: 2 }}
                >
                    {t('Administration.TryAgain', "Próbáld újra")}
                </Button>
            )}

            <Snackbar
                open={snackOpen}
                autoHideDuration={4000}
                onClose={() => setSnackOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity={snackSeverity} sx={{ width: '100%' }}>
                    {snackMsg}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default Activation;
